var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCovs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124.5 119.6",
    style: {
      enableBackground: "new 0 0 124.5 119.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1896C2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.4,59.5c0-10.6-8.6-19.3-19.3-19.3s-19.3,8.6-19.3,19.3s8.6,19.3,19.3,19.3S82.4,70.2,82.4,59.5z  M48.8,59.5c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3c0,7.9-6.4,14.3-14.3,14.3C55.2,73.8,48.8,67.4,48.8,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.9,33.2c1-1.7,1.6-3.7,1.6-5.8c0-6.2-5-11.2-11.2-11.2S18,21.2,18,27.4c0,6.2,5,11.2,11.2,11.2 c2.3,0,4.4-0.7,6.1-1.8l7.2,7l3.5-3.6L38.9,33.2z M35.1,29.6c-0.6,1.6-1.9,2.9-3.5,3.6c-0.7,0.3-1.5,0.5-2.4,0.5 c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2C35.5,28.2,35.4,28.9,35.1,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103,11.2C103,5,97.9,0,91.7,0S80.5,5,80.5,11.2c0,3.2,1.3,6,3.4,8.1L73.9,36l4.3,2.6l10-16.7 c1.1,0.4,2.3,0.6,3.5,0.6C97.9,22.5,103,17.4,103,11.2z M86.6,14.8c-0.7-1-1.1-2.3-1.1-3.6c0-3.4,2.8-6.2,6.2-6.2S98,7.8,98,11.2 s-2.8,6.2-6.2,6.2c-0.3,0-0.5,0-0.8-0.1C89.2,17.2,87.6,16.2,86.6,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.3,97.1L74.3,97.1l-3-13.2L66.4,85l3,13.2c-3.8,1.8-6.4,5.7-6.4,10.1c0,6.2,5,11.2,11.2,11.2 s11.2-5,11.2-11.2C85.6,102.2,80.6,97.1,74.3,97.1z M74.3,114.6c-3.4,0-6.2-2.8-6.2-6.2c0-2.1,1-3.9,2.5-5c1-0.8,2.3-1.2,3.7-1.2 c0.4,0,0.8,0,1.2,0.1c2.9,0.6,5.1,3.1,5.1,6.1C80.6,111.8,77.8,114.6,74.3,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.3,53.2c-4.9,0-9.1,3.2-10.6,7.6l-13.7-1.5l-0.5,5l13.7,1.5c0.6,5.6,5.4,9.9,11.1,9.9 c6.2,0,11.2-5,11.2-11.2C124.5,58.2,119.5,53.2,113.3,53.2z M113.3,70.7c-2.8,0-5.1-1.8-5.9-4.4c-0.2-0.6-0.3-1.2-0.3-1.9 c0-1.1,0.3-2.2,0.8-3.1c1.1-1.9,3.1-3.1,5.4-3.1c3.4,0,6.2,2.8,6.2,6.2S116.7,70.7,113.3,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.1,65.5l-17.2,5.6c-2-3.3-5.5-5.5-9.6-5.5C5,65.7,0,70.7,0,76.9s5,11.2,11.2,11.2s11.2-5,11.2-11.2 c0-0.3,0-0.7-0.1-1l17.2-5.6L38.1,65.5z M17.4,77.5c-0.3,3.1-3,5.6-6.2,5.6c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2 c1.9,0,3.5,0.8,4.6,2.1c1,1.1,1.6,2.6,1.6,4.1C17.5,77.1,17.5,77.3,17.4,77.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovs);
export default __webpack_public_path__ + "static/media/COVS.425bffd652091666d85ed1ffff48ed05.svg";
export { ForwardRef as ReactComponent };